// extracted by mini-css-extract-plugin
export default {"markdown":"TdNdh7f6IGdVOGToBkdO","fade-in":"cR5VXIoe5TAx0wjDtEoI"};